<template>
    <div :class="['dimmer border-top' , loading ?  'active' : '']">
        <div class="loader"></div>
        <div class="dimmer-content">
            <div class="card">
                <div class="card-content px-0">
                    <div class="modal-header d-flex align-items-center">
                        <h5 class="modal-title font-weight-400 mb-0">{{ model.name }} {{ model.last_name }}</h5>
                        <button v-if="!model.status" @click="action('activate')"
                                class="btn btn-primary shadow-none btn-sm">Activate
                        </button>
                        <button v-else @click="action('de-activate')" class="btn btn-primary shadow-none btn-sm">
                            De-activate
                        </button>
                    </div>
                    <div class="p-4">
                        <div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <div><strong>{{ model.name }}</strong></div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <div><strong>{{ model.last_name }}</strong></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <div><strong>{{ model.email }}</strong></div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Phone</label>
                                        <div><strong>{{ model.phone }}</strong></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 px-0">
                                <h3 class="text-5 font-weight-400 mt-3">Permissions</h3>
                                <hr>
                            </div>

                            <div class="col-12 px-4 pb-4">
                                <div v-for="permission in model.permissions" class="">
                                    <label class="custom-control-label"
                                           :for="`permissions-${permission.id}`">{{ permission.name }}</label>
                                </div>
                            </div>
                            <router-link :class="['btn btn-primary btn-block mt-2']"
                                         :to="`/business/users/${$route.params.id}/edit`">Edit User
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Index",
    data() {
        return {
            loading: false,
            model: {
                permissions: []
            },
        };
    },

    mounted() {
        this.init();
    },

    methods: {

        action(action) {
            this.loading = true;
            window.axios.get(`/business/users/${this.$route.params.id}/update/${action}`).then((response) => {
                this.model = response.data.body.model;
                this.loading = false;
            });
        },

        init() {
            this.loading = true;
            window.axios.get(`/business/users/${this.$route.params.id}/view/list`).then((response) => {
                this.model = response.data.body.model;
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>

</style>
